module.exports = __webpack_public_path__ + "img/check-attendance-while-presenting.d8735276.gif";